import styled from 'styled-components';
import {backgroundColor2, fontSize2} from "../Shared/Styles";

export default styled.select`
  ${backgroundColor2}
  ${fontSize2}
  color: #1163c9; 
  border: 1px solid;
  float: right; 
`;
